import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Eye.tsx
const EyeIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		d: "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
		fill: props.fill || "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 5c3.903 0 7.736 2.236 9.894 6.553a1 1 0 0 1 0 .894C19.736 16.764 15.904 19 12 19c-3.903 0-7.736-2.236-9.894-6.553a1 1 0 0 1 0-.894C4.264 7.236 8.096 5 12 5Zm-7.87 7c1.868 3.38 4.901 5 7.87 5 2.969 0 6.002-1.62 7.87-5C18.002 8.62 14.97 7 12 7c-2.969 0-6.002 1.62-7.87 5Z",
		fill: props.fill || "currentColor"
	})]
}));
//#endregion
export { EyeIcon };
